// The temperature reading is an unsigned 12-bit integer value in 7.5 fixed-point format representing degrees Celsius (C) in the range -40C to +85C. Convert the 12-bit integer value ($rdg in code below) to degrees Celsius ($tmp in code below) using the following algorithm:

/*
$tmp = -40.0;
if ( $rdg == 0xFFF ) {
  $tmp = null; // display reading as “invalid”
} else {
  // 7.5 fixed point format with 0 at -40C,
  $tmp = ((float)$rdg / 32.0) - 40.0;
}
*/

export function temperature(
  reading: number
  // scale: number,
  // offset: number,
  // frequency: number
): number {
  // 7.5 fixed point format with 0 at -40C,
  return reading / 32.0 - 40.0
}
